(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ka-collection"]) return;
  try {
    
function kaCatalogInit() {
  document.querySelectorAll('[data-ka-tags]').forEach(function(select) {
    if (select.dataset.bound) return;
    select.dataset.bound = 'true';
    select.addEventListener('change', function() {
      const next = new URL(select.value, location.origin);
      const sort = new URLSearchParams(location.search).get('sort_by');
      if (sort) next.searchParams.set('sort_by', sort);
      location.assign(next.toString());
    });
  });
  document.querySelectorAll('[data-ka-sort]').forEach(function(form) {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      const next = new URL(location.href);
      next.searchParams.set('sort_by', new FormData(form).get('sort_by'));
      next.searchParams.delete('page');
      location.assign(next.toString());
    });
  });
}
kaCatalogInit();
document.addEventListener('shopify:section:load', kaCatalogInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-header"]) return;
  try {
    
document.addEventListener('keydown',function(event){if(event.key==='Escape'){var openMenus=document.querySelectorAll('.ka-header details[open]');var lastMenu=openMenus[openMenus.length-1];if(lastMenu){lastMenu.removeAttribute('open');lastMenu.querySelector('summary').focus()}}});
document.addEventListener('click',function(event){if(!event.target.closest('.ka-header'))document.querySelectorAll('.ka-header details[open]').forEach(function(group){group.removeAttribute('open')})});
document.addEventListener('toggle',function(event){var group=event.target;if(!group.open||!group.matches('.ka-menu-branch,.ka-menu-subbranch'))return;var siblings=group.matches('.ka-menu-branch')?group.closest('.ka-menu-tree').querySelectorAll('.ka-menu-item > .ka-menu-branch'):group.parentElement.querySelectorAll(':scope > .ka-menu-subbranch');siblings.forEach(function(sibling){if(sibling!==group)sibling.removeAttribute('open')})},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var button=event.target.closest('[data-ka-review-step]');if(!button)return;var section=button.closest('section');var rail=section.querySelector('.ka-reviews');if(!rail)return;var card=rail.querySelector('figure');var step=card?card.getBoundingClientRect().width+28:rail.clientWidth;rail.scrollBy({left:step*Number(button.dataset.kaReviewStep),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})});

  } catch(e) { console.error(e); }
})();
})();
